import type { TAnswers, TTopUpState } from './types';

export const initialAnswers: TAnswers = {
    amounts: {
        currentProperty: '',
        amountTopUp: '',
        isGepValid: true,
        transactionDate: null,
    },
    summery: {
        checkFirst: false,
        checkSecond: false,
    },
};

export const initialTopUpState: TTopUpState = {
    answers: initialAnswers,
    portfolio: null,
    exAnteTopUp: null,
    fees: null,
    allocations: null,
    validations: null,
    currentProperty: null,
    currentPropertyRange: null,
};
